import React from "react";
import { SiMicrosoftexcel } from "react-icons/si";

const ExcelFloatingButton = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      position: "fixed",
      bottom: 32,
      right: 32,
      backgroundColor: "#1d6f42",
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: 60,
      height: 60,
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      cursor: "pointer",
      fontSize: 32,
      transition: "background 0.2s"
    }}
    title="Exportar para Excel"
    onMouseOver={e => e.currentTarget.style.backgroundColor = "#218c53"}
    onMouseOut={e => e.currentTarget.style.backgroundColor = "#1d6f42"}
  >
    <SiMicrosoftexcel size={32} />
  </button>
);

export default ExcelFloatingButton;